import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { ContentfulImage } from '@garnish/media';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroPartnerImage = (props: Props) => {
  const { url, alt } = props;

  return (
    <ContentfulImage
      baseUrl={url}
      options={IMAGE_OPTIONS}
      contentFit="cover"
      style={StyleSheet.absoluteFill}
      alt={alt}
    />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_OPTIONS: ContentfulImageOptions = {
  fm: 'webp',
  fit: 'fill',
  q: 80,
  w: 882,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  alt: string;
  url: string;
};

type ContentfulImageOptions = ComponentProps<typeof ContentfulImage>['options'];
